import axios from "axios";
import { authHeader, multipartHeader } from "./auth-header";

const getAll = () => {
  return axios.get(process.env.REACT_APP_API_URL + `storageCategories/list/`, {
    headers: authHeader(),
    data: {},
    params: {},
  });
};

const get = (id) => {
  return axios.get(process.env.REACT_APP_API_URL + `storageCategory/view/${id}`, {
    headers: authHeader(),
  });
};

const update = (id, data) => {
  return axios.put(process.env.REACT_APP_API_URL + `storageCategory/update/${id}`, data, {
    headers: multipartHeader(),
  });
};

export default { 
  getAll,
  get,
  update
};